import { Badge } from "@/components/ui/badge";
import type { BountyStatus } from "@/lib/types";

const statusConfig: Record<BountyStatus, { label: string; className: string }> = {
	open: {
		label: "Open",
		className: "bg-emerald-500/10 text-emerald-600 border-emerald-500/20 hover:bg-emerald-500/10",
	},
	in_review: {
		label: "In Review",
		className: "bg-amber-500/10 text-amber-600 border-amber-500/20 hover:bg-amber-500/10",
	},
	awarded: {
		label: "Awarded",
		className: "bg-blue-500/10 text-blue-600 border-blue-500/20 hover:bg-blue-500/10",
	},
	expired: {
		label: "Expired",
		className: "bg-muted text-muted-foreground border-border hover:bg-muted",
	},
};

export function StatusBadge({ status }: { status: BountyStatus }) {
	const config = statusConfig[status];
	return (
		<Badge variant="outline" className={config.className}>
			{config.label}
		</Badge>
	);
}
